import React from "react";
import './sdJourney.scss';

class SDJourney extends React.Component {
    constructor(props) {
        super(props);
        
        let date = new Date(props.memo.year, props.memo.month, props.memo.day);
        let dates = `${date.getFullYear()}-${date.toLocaleString('en-us', { month: 'short' })}-${date.getDate()}`;
        
        this.state = {
            ...props,
            time: this.setEvent(props.memo.memo),
            nowSelect: false,
            date: dates,
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.memo !== this.props.memo) { // => 比較更新前後的 state 屬性
            let date = new Date(this.props.memo.year, this.props.memo.month, this.props.memo.day);
            let dates = `${date.getFullYear()}-${date.toLocaleString('en-us', { month: 'short' })}-${date.getDate()}`;
            this.setState({
                ...this.props,
                time: this.setEvent(this.props.memo.memo),
                date: dates,
            })
        }
    }

    initTimeArray () {
        let time = [];

        for (let i = 0; i < 24; i++) {
            time.push({
                hour: i,
                time: i < 10 ? `0${i}:00` : `${i}:00`,
                event: '',
                select: false,
            })
        }

        return time;
    }

    setEvent(memo) {
        let timeArray = this.initTimeArray();
        memo.forEach(m => {
            for(let i = m.startHour; i <= m.endHour; i++) {
                let to = timeArray.find(t => t.hour === i);
                if (to) {
                    to.event = m;
                }
            }
        });

        return timeArray;
    }

    mouseDown = t => {
        this.setState({
            nowSelect: true,
            time: this.changeSelected(t),
        });
    }

    mouseUp = t => {
        this.setState({
            nowSelect: false
        });
    }

    hoverTime = t => {
        if (!this.state.nowSelect) return;

        this.setState({
            time: this.changeSelected(t),
        })
    }

    changeSelected = t => {
        let st = this.state.time;
        let m = st.find(tt => tt.time === t.time)
        m.select = !m.select;

        return st;
    }

    render() {
        return(
        <div className="journeyBody">
            <div>{this.state.date}</div>
            {this.state.time.map(t => {
                let ecn = ['etitle'];
                if (t.hour == t.event.startHour) ecn.push('estart');
                if (t.hour == t.event.endHour) ecn.push('eend');
                const mStyle = {
                    backgroundColor: t.event.color
                }
                return <div className={`time ${t.select ? 'selected' : ''}`} key={t.time} 
                onMouseDown={() => this.mouseDown(t)} 
                onMouseUp={() => this.mouseUp(t)}
                onMouseOver={() => this.hoverTime(t)}>
                    <div className="timename">{t.time}</div>
                    <div className={ecn.join(' ')} style={mStyle}>{t.event.title}</div>
                </div>
            })}
        </div>
        )
    }
}

export default SDJourney;